import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadList: -1,
    loadDetails: -1,
    updateSub: -1,
  },
  list: [],
  details: {},
  active: {},
};

export default function reducer(state = initialState, action) {
  const { type, error, payload } = action;

  switch (type) {
    // Get list
    case ACTION_TYPES.BPDATA_GET_PATIENTS_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 0,
        },
        error: null,
      };
    case ACTION_TYPES.BPDATA_GET_PATIENTS_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 1,
        },
        list: payload,
      };
    case ACTION_TYPES.BPDATA_GET_PATIENTS_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 2,
        },
        error,
      };

    // Get details
    case ACTION_TYPES.BPDATA_GET_DETAILS_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadDetails: 0,
        },
        error: null,
      };
    case ACTION_TYPES.BPDATA_GET_DETAILS_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          loadDetails: 1,
        },
        details: payload,
      };
    case ACTION_TYPES.BPDATA_GET_DETAILS_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadDetails: 2,
        },
        error,
      };

    // Get details
    case ACTION_TYPES.BPDATA_UPDATE_SUBSCRIPTION_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updateSub: 0,
        },
        error: null,
      };
    case ACTION_TYPES.BPDATA_UPDATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          updateSub: 1,
        },
      };
    case ACTION_TYPES.BPDATA_UPDATE_SUBSCRIPTION_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updateSub: 2,
        },
        error,
      };

    // Active patient
    case ACTION_TYPES.BPDATA_ACTIVE_PATIENT:
      return {
        ...state,
        active: payload.patient,
      };

    // Remove patient
    case ACTION_TYPES.BPDATA_REMOVE_PATIENT: {
      const newList = state.list.data.filter(p => p.patientID !== payload.patient.patientID);

      return {
        ...state,
        list: newList,
      };
    }

    default:
      return state;
  }
}
